package co.maytes.standupbot.dashboard.features.setup

import co.maytes.standupbot.shared.dto.setup.SetupStatusDto
import co.maytes.standupbot.shared.dto.setup.needsAttention
import co.maytes.standupbot.shared.dto.setup.reconnectNotices

data class SetupStatusState(
    val status: SetupStatusDto? = null,
    val loading: Boolean = false,
    val error: String? = null,
    val bannerHidden: Boolean = false,
    val failedRefreshes: Int = 0,
) {
    fun loadingStarted(): SetupStatusState = copy(loading = true)

    fun loaded(next: SetupStatusDto): SetupStatusState = copy(status = next, loading = false, error = null, failedRefreshes = 0)

    fun failed(message: String): SetupStatusState = copy(loading = false, error = message, failedRefreshes = failedRefreshes + 1)

    val stale: Boolean get() = status != null && failedRefreshes >= STALE_AFTER_MISSES

    fun bannerDismissed(): SetupStatusState = copy(bannerHidden = true)

    fun showsBanner(isAdmin: Boolean): Boolean =
        isAdmin && !bannerHidden && status?.reconnectNotices().orEmpty().isNotEmpty()

    fun needsAttention(isAdmin: Boolean): Boolean = isAdmin && status?.needsAttention() == true

    companion object {
        const val STALE_AFTER_MISSES = 2
    }
}
